import { useState } from "react";
import CustomModal from "../CustomModal";
import { Calendar } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import "./DatePickerModal.scss";

const DatePickerModal = ({ show, handleSubmit, handleClose }) => {
  const [value, setValue] = useState(null);

  const onChange = (newValue) => {
    setValue(newValue);
  };

  const onSubmit = () => {
    const selectedDate = value
      ? new Date(
          value.year,
          value.month.index,
          value.day,
          value.hour,
          value.minute
        )
      : new Date();
    handleSubmit(selectedDate);
    handleClose();
  };
  return (
    <CustomModal title="Seleziona Data" isVisible={show} onClose={handleClose}>
      <div className="date-picker-modal">
        <Calendar
          className="date-picker-calendar"
          value={value}
          onChange={onChange}
          plugins={[<TimePicker />]}
        />
      </div>
      <footer className="modal-footer">
        <button className="modal-footer-button" onClick={onSubmit}>
          Applica
        </button>
      </footer>
    </CustomModal>
  );
};

export default DatePickerModal;
